import React, { useContext } from 'react';
import { translations } from 'src/constants/translations';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import {
  UnitsDataContext,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { MarketplaceButton } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceButton';
import AddIcon from '@mui/icons-material/Add';
import {
  UnitsCardHeaderEntity,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/UnitsCardHeaderWithDivider/components/UnitsCardHeaderEntity';
import { RandomInteger } from 'src/helpers/randomInteger';
import { ReactSortable, Sortable, Store } from 'react-sortablejs';
import { useStyles } from '../Common/styles';

export const UnitsCardAdditionalInfoWithDivider: React.FC = () => {
  const styles = useStyles();
  const context = useContext(UnitsDataContext);
  const mainStyles = mainUseStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(!!context?.state.unitsCard.additionalInfo.isActive);

  const rocketChange = (state: boolean) => {
    if (context?.state.unitsOrder) {
      context.updateState((current) => ({
        ...current,
        unitsCard: { ...current.unitsCard, additionalInfo: { ...current.unitsCard.additionalInfo, isActive: state } },
      }));
      setRocketState(state);
    }
  };

  const add = () => {
    if (context) {
      const element = {
        '@id': RandomInteger().toString(),
        iconFileUri: null,
        prefix: null,
        suffix: null,
        property: {
          diType: 'PlacementProperty' as const,
          oldSystemName: null,
          systemName: '',
          translates: null,
        },
      };
      context.updateState((current) => ({
        ...current,
        unitsCard: { ...current.unitsCard, additionalInfo: { ...current.unitsCard.additionalInfo, elements: [...current.unitsCard.additionalInfo.elements, element] } },
      }));
    }
  };

  const moveToTrash = (index: number) => {
    if (context) {
      context.updateState((current) => ({
        ...current,
        unitsCard: { ...current.unitsCard, additionalInfo: { ...current.unitsCard.additionalInfo, elements: current.unitsCard.additionalInfo.elements.filter((_, itemIndex) => itemIndex !== index) } },
      }));
    }
  };

  return (
    <>
      <GroupWrapper
        name={translations.unitsCardAdditionalInfoWithDivider}
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => {
              setCollapseState(state);
            }}
          />
      )}
      >
        {collapseState === GroupWrapperCollapseState.OPEN && (
          <div className={styles.wrapper}>
            <div className={styles.text}>
              { translations.AddAnotherAdditionalInfoElement }
            </div>
            <div className={styles.buttonsWrapper}>
              <MarketplaceButton
                startIcon={<AddIcon />}
                label={translations.additionalInfoWithDivider}
                onClick={() => add()}
              />
            </div>
          </div>
        ) }
      </GroupWrapper>
      {context && (
        <ReactSortable<any>
          className={mainStyles.iteratorWrapper}
          animation={150}
          handle=".drag-handle"
          list={context.state.unitsCard.additionalInfo.elements.map((el) => ({ ...el, chosen: false }))}
          setList={(newList, sortable: Sortable | null, store: Store) => {
            if (store && store.dragging && store.dragging.props
              && JSON.stringify(store.dragging.props.list) !== JSON.stringify(newList)) {
              context.updateState((current) => ({
                ...current,
                unitsCard: { ...current.unitsCard, additionalInfo: { ...current.unitsCard.additionalInfo, elements: newList } },
              }));
            }
          }}
        >
          {collapseState === GroupWrapperCollapseState.OPEN && context.state.unitsCard.additionalInfo.elements.map((item, index) => (
            <React.Fragment key={item['@id']}>
              <UnitsCardHeaderEntity
                title="Additional info element with divider"
                entity={item}
                onChange={(entity) => context.updateState((current) => ({
                  ...current,
                  unitsCard: {
                    ...current.unitsCard,
                    additionalInfo: { ...current.unitsCard.additionalInfo, elements: current.unitsCard.additionalInfo.elements.map((element, itemIndex) => (itemIndex === index ? entity : element)) },
                  },
                }))}
                lang={context.state.marketplace.language}
                propertyOptions={context.state.placementPropertyOptions}
                moveToTrash={() => moveToTrash(index)}
              />
            </React.Fragment>
          ))}
        </ReactSortable>
      )}
    </>
  );
};
